import React from 'react';
import {Field} from 'redux-form';
import {BaseField} from '../../../../../../../shared/components/baseField';
import {Platform, TouchableOpacity, View} from 'react-native';
import {useTheme} from '../../../../../../../shared/theme';
import {useStyles} from '../../../../../../../shared/hooks/styles';
import {ViewProps} from './model';
import {Text} from '../../../../../../../shared/components/text';
import {images} from '../../../../../../../assets/icons';
import {DeviceSize} from '../../../../../../../shared/theme/helpers';
import {useIsDesktop} from '../../../../../../../shared/hooks/useIsDesktop';

export default ({
  name,
  value,
  label,
  type,
  error,
  formatter,
  isChanging,
  editable = false,
  onTurnChanging,
  onAccept,
  onDecline,
  ...rest
}: ViewProps) => {
  const theme = useTheme();
  const isDesktop = useIsDesktop();
  const styles = useStyles(({mediaOnly}) => ({
    root: {
      marginBottom: 10,
      flexDirection: 'row',
    },
    rootMobile: {
      position: 'relative',
      marginBottom: 24,
      backgroundColor: theme.color.backgroundMenuColor,
      paddingVertical: 8,
      paddingHorizontal: 20,
      borderRadius: 14,
    },
    rootMobileCheckbox: {
      width: 56,
      paddingHorizontal: 16,
    },
    left: {
      flex: 1,
      justifyContent: 'center',
      marginRight: 24,
    },
    label: {
      color: theme.helpText.color,
      marginBottom: 4,
      ...mediaOnly(DeviceSize.desktop, theme.fonts.body, {...theme.fonts.bodySmallLight}),
    },
    value: {
      ...(isDesktop ? {...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, {...theme.fonts.body})} : {}),
      minHeight: 40,
      textAlignVertical: Platform.OS === 'android' ? 'center' : undefined,
      paddingTop: Platform.OS === 'ios' ? 9 : 0,
    },
    mobileLabel: {
      marginBottom: 12,
      textAlign: 'center',
    },
    right: {
      justifyContent: 'center',
      alignItems: 'center',
    },
    error: {
      color: theme.input.common.errorColor,
    },
    buttons: {
      height: 48,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 'auto',
    },
    button: {
      width: 48,
      height: 48,
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 'auto',
    },
  }));
  const iconColor = theme.color.textColor;

  return (
    <>
      {Platform.OS === 'web' ? null : (
        <Text type='h6Light' style={styles.mobileLabel}>
          {label}
        </Text>
      )}
      <View
        testID={`esia-reg-card-form-field-wrapper_${name}`}
        style={[
          styles.root,
          Platform.OS !== 'web' ? styles.rootMobile : undefined,
          Platform.OS !== 'web' && type === 'checkbox' ? styles.rootMobileCheckbox : undefined,
        ]}>
        <View style={styles.left}>
          {Platform.OS === 'web' ? <Text style={styles.label}>{label}</Text> : null}
          {isChanging ? (
            <Field
              testIDprefix={`esia-reg-card-form-field_${name}`}
              component={BaseField}
              name={name}
              type={type}
              style={Platform.OS === 'web' ? {width: '100%'} : {}}
              containerStyle={Platform.OS !== 'web' ? {marginTop: -22} : {}}
              autoFocus
              normalize={(fieldValue: string) => {
                if (name === 'email') {
                  const noBlanksEmail = fieldValue.replace(/\s/g, '');
                  return noBlanksEmail;
                }
                return fieldValue;
              }}
              {...rest}
            />
          ) : (
            <View>
              <Text style={styles.value}>{formatter ? formatter(value) : value}</Text>
              {error ? (
                <Text style={styles.error} type='caption'>
                  {error}
                </Text>
              ) : null}
            </View>
          )}
        </View>
        {editable ? (
          <View style={styles.right}>
            {isChanging ? (
              <View style={styles.buttons}>
                <TouchableOpacity style={styles.button} testID={`edit-reg-card-check-${name}`} onPress={onAccept}>
                  <images.Check height={24} width={24} color={iconColor} />
                </TouchableOpacity>
                <TouchableOpacity style={styles.button} testID={`edit-reg-card-close-${name}`} onPress={onDecline}>
                  <images.Close height={24} width={24} color={iconColor} />
                </TouchableOpacity>
              </View>
            ) : (
              <TouchableOpacity style={styles.button} testID={`edit-reg-card-pencil-${name}`} onPress={onTurnChanging}>
                <images.Pencil height={18} width={18} color={iconColor} />
              </TouchableOpacity>
            )}
          </View>
        ) : null}
      </View>
    </>
  );
};
